<template>
  <vx-card class="vx-card_full-height">
    <div class="mb-4">
      <vs-button
        :to="{ name: 'uc_notifies'}"
        type="border"
        icon="keyboard_backspace"
      >
        К списку уведомлений
      </vs-button>
    </div>
    <h3 class="mb-8">Создать уведомление</h3>

    <div v-if="!preview" class="">
      <div :class="$style.templateSelect">
        <elsa-v-select
          html-label="Тип документа"
          v-model="data.template"
          :options="templates"
          label="notify_name"
          :clearable="false"
          @input="saveTemp()"
        />
      </div>

      <div :class="$style.date">
        <elsa-v-datepicker
          label="Дата создания документа"
          v-model="data.date"
          :clearable="false"
          @input="saveTemp()"
        />
      </div>

      <div :class="$style.apartment">
        <div :class="$style.apartmentType">
          <elsa-v-select
            html-label="Тип помещения"
            v-model="data.apartmentType"
            :options="apartmentTypes"
            label="name"
            :clearable="false"
            @input="data.apartment = null; debts = [];saveTemp()"
          />
        </div>

        <div :class="$style.apartmentNumber">
          <elsa-v-select
            html-label="Номер помещения"
            v-model="data.apartment"
            :options="apartmentsFilteredByType"
            :loading="!apartments.length"
            :getOptionLabel="getApartmentLabel"
            :clearable="false"
            :disabled="data.apartmentType === null || !apartmentsFilteredByType.length"
            :danger="!!errors.apartment"
            :danger-text="errors.apartment"
            @input="data.debts = []; saveTemp()"
          />
        </div>
      </div>


      <h4>Расчет общей суммы задолженности</h4>
      <p>Проверьте месяцы с задолженностью, за которые нужно сформировать претензию</p>
      <div v-if="data.apartment" class="mb-8">
        <checkbox-tree
          ref="tree"
          :tree="debtsTree"
          v-model="data.debts"
          @input="saveTemp()"
        />
        <div v-if="errors.debts" :class="$style.error">{{ errors.debts }}</div>
        <p><b>Выбрано:</b> {{ debtsSelected }}/{{ debtsTotal }} месяцев с задолженностью</p>
        <p><b>Итого:</b> {{ debtsSum }}₽</p>
      </div>
      <div v-else :class="$style.empty">Выберите помещение</div>

      <h4>Расчет статей</h4>
      <p>Добавьте статьи (группы тарифов) из автонастроек</p>
      <div :class="$style.articles">
        <div :key="i" v-for="(article, i) in data.articles" :class="$style.article">
          <elsa-v-select
            :class="$style.articleSelect"
            v-model="article.article"
            :options="freeArticles"
            label="article_name"
            @input="onChangeArticle(i)"
          />
          <div v-if="article.sum" :class="$style.articeSum">{{ article.sum }}₽</div>
          <vs-button
            :class="$style.deleteArticleButton"
            color="primary"
            type="border"
            icon="delete_outline"
            @click="onDeleteArticle(i)"
            tabindex="-1"
            title="Удалить строку"
          />
        </div>
        <vs-button
          :class="$style.addArticleButton"
          color="success"
          icon="add"
          @click="onAddArticle"
        >
          Добавить статью
        </vs-button>
        <div v-if="errors.articles" :class="$style.error">{{ errors.articles }}</div>
      </div>


      <!--      <div :class="$style.close">-->
      <!--        <elsa-v-datepicker-->
      <!--          label="Предлагаем погасить задолженность до:"-->
      <!--          v-model="data.close"-->
      <!--          :clearable="false"-->
      <!--          :danger="!!errors.date_debt_close"-->
      <!--          :danger-text="errors.date_debt_close"-->
      <!--        />-->
      <!--      </div>-->

      <div :class="$style.select">
        <elsa-v-select
          html-label="Ограничение услуг"
          v-model="data.limit"
          :options="limitedServices"
          :multiple="true"
          label="name"
          :danger="!!errors.limit"
          :danger-text="errors.limit"
          @input="saveTemp()"
        />
      </div>

      <div :class="$style.select">
        <elsa-v-select
          html-label="Приостановление услуг"
          v-model="data.disable"
          :options="disabledServices"
          :multiple="true"
          label="name"
          :danger="!!errors.disable"
          :danger-text="errors.disable"
          @input="saveTemp()"
        />
      </div>

      <!--      <vs-checkbox class="mb-2" v-model="data.stamp">Добавить скан печати управляющей компании</vs-checkbox>-->
      <!--      <vs-checkbox class="mb-8" v-model="data.signature">Добавить скан подписи генерального директора</vs-checkbox>-->

      <vs-checkbox class="mb-8" v-model="data.showRestrict">Выводить сообщение об оплате расходов</vs-checkbox>

      <div :class="$style.create">
        <vs-button
          :class="$style.createButton"
          type="border"
          @click="onCreate"
        >
          Далее
        </vs-button>
        <div v-if="hasErrors" :class="$style.createError">В форме имеются ошибки</div>
      </div>
    </div>
    <div v-else :class="$style.preview">
      <div :class="$style.previewContent">
        <div :class="$style.previewImage">
          <img :src="preview" alt="" />
        </div>
      </div>
      <div v-if="document" :class="$style.footer">
        <div class="mx-2">
          <app-icon name="CheckIcon" size="14px" :class="$style.checkIcon" />
          Документ сгенерирован.
        </div>
        <vs-button class="mx-2" target="_blank" :href="document.path | imgPath">
          Открыть PDF на просмотр и печать
        </vs-button>
      </div>
      <div v-else :class="$style.footer">
        <vs-button class="mx-2" type="border" @click="onCancelPreview">Назад, к редактированию</vs-button>
        <vs-button class="mx-2" color="success" @click="onGenerate">Все верно, сгенерировать</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import parseDate         from "@/client/helpers/parseDate";
import arrayToIdIndex    from "@/client/helpers/arrayToIdIndex";
import currency          from 'currency.js';
import formatDate        from "@/client/helpers/formatDate";
import mergeCommonErrors from "@/helpers/mergeCommonErrors";
import CheckboxTree      from "@/components/CheckboxTree";

const initialErrors = {
  apartment: null,
  debts:     null,
  articles:  null,
  // date_debt_close: null,
  limit:   null,
  disable: null,
};

export default {
  name:       "NotifiesCreate",
  components: { CheckboxTree },
  data() {
    return {
      tempData:         {},
      data:             {
        template:      null,
        date:          new Date(),
        apartmentType: null,
        apartment:     null,
        debts:         [],
        articles:      [],
        // close:         new Date(),
        limit:   [],
        disable: [],
        // stamp:         false,
        // signature:     false,
        showRestrict: true,
      },
      errors:           { ...initialErrors },
      templates:        [],
      articles:         [],
      apartments:       [],
      debtsTree:        [],
      debtsDict:        {},
      limitedServices:  [],
      disabledServices: [],

      preview:  null,
      document: null,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    apartmentTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },

    apartmentsFilteredByType() {
      const { apartments, data: { apartmentType } } = this;
      if (!apartmentType || !apartments) return [];
      return apartments.filter(apartment => apartment.type_apart === apartmentType.id);
    },

    debtsTotal() {
      return Object.keys(this.debtsDict).length;
    },

    debtsSelected() {
      return this.data.debts.length;
    },

    debtsSum() {
      return this.data.debts.reduce(( total, month ) => {
        const debt = this.debtsDict[month];
        if (!debt) return total;
        return total.add(debt.sum).add(debt.fine);
      }, currency(0)).toString();
    },

    hasErrors() {
      for (let key in this.errors) {
        if (this.errors[key]) return true;
      }
      return false;
    },

    freeArticles() {
      if (!Array.isArray(this.articles)) return [];
      const takenArticles = this.data.articles.reduce(( dict, article ) => {
        if (article.article) dict[article.article.id] = true;
        return dict;
      }, {});
      return this.articles.filter(a => !takenArticles[a.id]);
    },
  },
  methods:  {
    loadTemplates() {
      this.$http.get('notify/templates', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.templates = data;

        const { tempData } = this;
        const type = tempData ? +tempData.type : null;
        this.data.template = type ? data.find(t => t.id === type) : data[0];
      });
    },

    loadArticles() {
      if (!this.data.template) return;
      this.articles = null;
      this.$http.get('notify/articles', {
        params: {
          type_id:      this.data.template.id,
          buildings_id: this.selectedHouseId,
        },
      }).then(( { data: { articles } } ) => {
        const activeArticlesDict = {};
        this.articles = articles;
        this.data.articles = articles
          .filter(a => a.auto_add)
          .map(article => {
            activeArticlesDict[article.id] = true;
            return { article, sum: null };
          });

        const { tempData } = this;
        if (Array.isArray(tempData.articles)) tempData.articles.forEach(( articleId ) => {
          const article = articles.find(a => a.id === articleId);
          if (article && !activeArticlesDict[article.id]) {
            activeArticlesDict[article.id] = true;
            this.data.articles.push({ article, sum: null });
          }
        });

        this.data.articles.forEach(this.updateArticleDebt);
      });
    },

    loadAccounts() {
      this.apartments = [];
      return this.$http.get(`notify/apartments/${this.selectedHouseId}`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.apartments = data;

        const { tempData, apartmentTypes } = this;
        const apartmentId = tempData ? +tempData.apartment_id : null;
        const selectedApartment = apartmentId ? data.find(t => t.id === apartmentId) || null : null;
        this.data.apartmentType = selectedApartment ? apartmentTypes.find(at => at.id === selectedApartment.type_apart) : apartmentTypes[0];
        this.data.apartment = selectedApartment;
      });
    },

    loadDebts() {
      const { apartment } = this.data;
      if (!apartment) return;
      this.$http.get(`notify/debts`, {
        params: {
          apartment_id: apartment.id,
          buildings_id: this.selectedHouseId,
        },
      }).then(( { data: { message: debts } } ) => {
        debts = debts.map(( { debt, fine, month } ) => {
          const sum = currency(debt).add(fine);
          return {
            month:     month,
            monthDate: parseDate(month),
            sum:       sum.value,
            sumStr:    sum.toString(),
          };
        }).sort(( d1, d2 ) => d1.month === d2.month ? 0 : d1.month > d2.month ? 1 : -1);


        this.debtsDict = arrayToIdIndex(debts, 'month');
        this.debtsTree = [{
          title:      `Вся задолженность`,
          selectable: true,
          expanded:   true,
          children:   debts.map(debt => ({
            title:      <span><b>{formatDate(debt.monthDate, 'LLLL yyyy')}</b> - {debt.sumStr}₽</span>,
            selectable: true,
            value:      debt.month,
          })),
        }];

        const { tempData } = this;
        if (tempData.months) {
          this.data.debts = tempData.months.filter(( month ) => this.debtsDict[month]);
        }
      });
    },

    loadLimited() {
      this.$http.get(`notify/services`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        const { disable_services, limitable_services } = data;
        this.limitedServices = limitable_services;
        this.disabledServices = disable_services;

        const { tempData } = this;
        if (Array.isArray(tempData.limitable_services) && tempData.limitable_services.length) {
          this.data.limit = tempData.limitable_services.reduce(( list, limitId ) => {
            const limit = limitable_services.find(item => item.id === limitId);
            if (limit) list.push(limit);
            return list;
          }, []);
        }
        if (Array.isArray(tempData.disable_services) && tempData.disable_services.length) {
          this.data.disable = tempData.disable_services.reduce(( list, disableId ) => {
            const disable = disable_services.find(item => item.id === disableId);
            if (disable) list.push(disable);
            return list;
          }, []);
        }
      });
    },

    getArticleDebt( articleId ) {
      const { apartment, debts } = this.data;
      if (!debts.length || !apartment) return Promise.resolve(0);
      return this.$http.get(`notify/article/${articleId}/debt`, {
        params: {
          buildings_id:   this.selectedHouseId,
          account_number: apartment.account_number,
          // article_id:     articleId,
          months: debts,
        },
      }).then(( { data } ) => currency(data.sum).add(data.fine).toString());
    },

    loadTemp() {
      return this.$http.get(`notify/temp`, { params: { buildings_id: this.selectedHouseId } }).then(
        ( { data } ) => {
          this.tempData = data;
          const { create_date, show_message } = data;
          if (create_date) this.data.date = parseDate(create_date);
          if (typeof show_message === 'boolean') this.data.showRestrict = show_message;
        },
        () => this.tempData = {},
      );
    },


    saveTemp() {
      const { template, apartment, date, articles, debts, limit, disable, showRestrict } = this.data;
      this.$http.post(`notify/temp`, {
        buildings_id:     this.selectedHouseId,
        type:             template ? template.id : null,
        create_date:      formatDate(date, 'dd-MM-yyyy'),
        apartment_id:     apartment ? apartment.id : null,
        months:           debts,
        articles:         articles.filter(a => a.article).map(article => article.article.id),
        limit_services:   Array.isArray(limit) ? limit.map(item => item.id) : [],
        disable_services: Array.isArray(disable) ? disable.map(item => item.id) : [],
        show_message:     showRestrict,
      });
    },

    updateApartmentType() {
      const { apartmentType } = this.data;
      if (apartmentType === null || !this.apartmentTypes.find(type => type.id === apartmentType.id)) {
        this.data.apartmentType = this.apartmentTypes[0];
      }
    },

    updateArticleDebt( article ) {
      if (!article.article) {
        article.sum = null;
        return;
      }
      this.getArticleDebt(article.article.id).then(( data ) => {
        article.sum = data;
      });
    },

    getApartmentLabel( apartment ) {
      return `${apartment.number} #${apartment.account_number}`;
    },

    validate() {
      const errors = { ...initialErrors };
      const { data } = this;
      if (!data.apartment) errors.apartment = 'Выберите помещение';
      if (!data.debts.length) errors.debts = 'Выберите хотя бы 1 месяц';
      // if (!data.articles.filter(a => !!a.article).length) errors.articles = 'Выберите хотя бы 1 статью';
      if (!data.limit && !data.disable) errors.disable = errors.limit = 'Выберите ограничение или приостановление услуг';
      this.errors = errors;
    },

    serializeForm( { isPreview } ) {
      this.validate();
      if (this.hasErrors) return null;

      const {
              template,
              apartment,
              date,
              debts,
              articles,
              close,
              limit,
              disable,
              stamp,
              signature,
              showRestrict,
            } = this.data;
      console.log(limit);
      console.log(disable);
      return {
        buildings_id: this.selectedHouseId,
        type:         template.type,
        type_id:      template.id,
        apartment_id: apartment.id,
        create_date:  formatDate(date, 'yyyy-MM-dd'),
        comment:      '',
        // date_debt_close:        formatDate(close, 'yyyy-MM-dd'),
        // legal_entity_print:     stamp,
        // legal_entity_signature: signature,
        params:     {
          months:           debts.map(month => ({
            month,
            debt: this.debtsDict[month].sum,
          })),
          sum:              +this.debtsSum,
          articles:         articles.filter(a => a.article).map(article => ({
            id:   article.article.id,
            name: article.article.article_name,
            sum:  +article.sum,
          })),
          limit_services:   Array.isArray(limit) && limit.length ? limit : null,
          disable_services: Array.isArray(disable) && disable.length ? disable : null,
          payment_text:     showRestrict,
        },
        is_preview: isPreview,
      };
    },

    onAddArticle() {
      this.data.articles.push({
        article: null,
        sum:     null,
      });
      this.errors.articles = null;
    },

    onDeleteArticle( index ) {
      this.data.articles.splice(index, 1);
      this.saveTemp();
    },

    onChangeArticle( index ) {
      const article = this.data.articles[index];
      this.updateArticleDebt(article);
      this.saveTemp();
    },

    onCreate() {
      const data = this.serializeForm({ isPreview: true });
      if (!data) return;
      return this.$http.post(`notify`, data, { responseType: 'arraybuffer' }).then(
        ( { data } ) => {
          this.preview = window.URL.createObjectURL(new Blob([data]));
        },
        ( e ) => {
          const decoder = new TextDecoder("utf-8");
          const errors = JSON.parse(decoder.decode(e.response.data));
          console.log(errors);
          this.errors = mergeCommonErrors(errors.errors, Object.keys(initialErrors));
          if (this.errors.common) this.$vs.notify({
            color: 'danger',
            time:  10000,
            title: 'Ошибка',
            text:  this.errors.common,
          });
        },
      );
    },

    onCancelPreview() {
      this.preview = null;
    },

    onGenerate() {
      const data = this.serializeForm({ isPreview: false });
      if (!data) return;
      return this.$http.post(`notify`, data).then(
        ( { data } ) => {
          this.document = data;
        },
        ( e ) => {
          const errors = mergeCommonErrors(e.response.data, []);
          if (errors.common) this.$vs.notify({
            color: 'danger',
            time:  10000,
            title: 'Ошибка',
            text:  errors.common,
          });
        },
      );
    },
  },
  mounted() {
    this.loadTemp().then(() => {
      this.updateApartmentType();
      this.loadTemplates();
      this.loadAccounts();
      this.loadArticles();
      this.loadLimited();

    });
  },
  watch: {
    selectedHouseId() {
      this.loadTemp().then(() => {
        this.loadAccounts();
        this.loadArticles();

        this.data.apartment = null;
      });
    },
    apartmentTypes() {
      this.updateApartmentType();
    },
    'data.template'() {
      this.loadArticles();
    },
    'data.apartmentType'() {
      // this.data.apartment = null;
      // this.debts = [];
    },
    'data.apartment'() {
      this.loadDebts();
      // this.data.debts = [];
      this.errors.apartment = null;
    },
    'data.debts'() {
      this.data.articles.forEach(this.updateArticleDebt);
      this.errors.debts = null;
    },
    'data.limit'() {
      this.errors.limit = this.errors.disable = null;
    },
    'data.disable'() {
      this.errors.limit = this.errors.disable = null;
    },
  },
};
</script>

<style lang="scss" module>
.templateSelect {
  width: 450px;
  margin-bottom: 2em;
}

.date {
  width: 220px;
  margin-bottom: 2em;
}

.apartment {
  display: flex;
  margin-bottom: 2em;
}

.apartmentType {
  width: 160px;
  margin-right: 1em;
}

.apartmentNumber {
  width: 280px;
}

.empty {
  font-size: 1.15em;
  opacity: .5;
  font-style: italic;
  margin: 1em 0 3em;
}

.articles {
  width: 560px;
  margin: 1em 0 3em;
}

.addArticleButton {
  width: 100%;
}

.article {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}

.articleSelect {
  width: 350px;
}

.articeSum {
  margin-left: 1em;
}

.deleteArticleButton {
  margin-left: auto;
}

.select {
  width: 670px;
  margin-bottom: 2em;
}

.create {
  display: flex;
  align-items: center;
}

.createButton {
  width: 200px;
}

.createError {
  color: color(danger);
  margin-left: 1em;
}

.error {
  color: color(danger);
  margin-top: .5em;
}

.treeRoot {
  display: inline-block;
  vertical-align: middle;
}

.preview {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 -1.5rem -1.5rem;
}

.previewContent {
  flex: 1;
  min-height: 0;
  position: relative;
}

.previewImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #D2D6D9;

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}

.footer {
  //height: 120px;
  border-top: 1px solid #D2D6D9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
}

.checkIcon {
  color: color(success);
  margin-right: .25em;
  vertical-align: middle;
}

</style>
